const schemaJSON = require('./schema.json');

export function getSchemaIntrospection() {
  return schemaJSON;
}
